import { createAction, createReducer } from 'deox';

export interface CorrelationId {
  id: string | null;
}

const defaultState: CorrelationId = {
  id: null,
};

export const setCorrelationId = createAction(
  'SET_USER_SESSION_ID',
  resolve => (token: string) => resolve(token),
);

export const correlationIdReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(setCorrelationId, (state, { payload: id }) => ({
      ...state,
      id,
    })),
  ],
);

interface MountedState {
  correlationId: CorrelationId;
}

export const selectCorrelationId = (state: MountedState): string => {
  if (!state.correlationId.id)
    throw new Error('Expect the Correlation ID to exist');

  return state.correlationId.id;
};

export default correlationIdReducer;
